import React from "react";
import { Col, Row } from "reactstrap";
import FormInput from "../components/common/form/FormInput";
import FormInputSelect from "../components/common/form/FormInputSelect";

class SignupForm extends React.Component {
    showField() {
        return this.props.isEdit === true ? "hidden" : "";
    }

    isSuperAdminView() {
        return this.props.isSuperAdminView === true ? "" : "";
    }

    render() {
        let adminRoleList = [];
        adminRoleList.push({
            key: "ROLE_SUPER_ADMIN",
            value: "ROLE_SUPER_ADMIN",
        });
        adminRoleList.push({ key: "ROLE_ADMIN", value: "ROLE_ADMIN" });
        adminRoleList.push({
            key: "ROLE_LEVEL1",
            value: "ROLE_LEVEL1",
        });
        adminRoleList.push({
            key: "ROLE_LEVEL2",
            value: "ROLE_LEVEL2",
        });
        adminRoleList.push({
            key: "ROLE_LEVEL3",
            value: "ROLE_LEVEL3",
        });
        adminRoleList.push({
            key: "ROLE_STARTER",
            value: "ROLE_STARTER",
        });
        adminRoleList.push({
            key: "ROLE_BASIC",
            value: "ROLE_BASIC",
        });
        adminRoleList.push({
            key: "ROLE_ADVANCE",
            value: "ROLE_ADVANCE",
        });
        adminRoleList.push({
            key: "ROLE_PRO",
            value: "ROLE_PRO",
        });
        adminRoleList.push({
            key: "ROLE_BUISNESS",
            value: "ROLE_BUISNESS",
        });
        adminRoleList.push({
            key: "ROLE_FREE",
            value: "ROLE_FREE",
        });
        return (
            <>
                <Row>
                    <Col md="12">
                        <FormInput
                            name="firstName"
                            className="form-control-label"
                            id="firstName"
                            placeholder="inputPlaceHolder.admin.firstName"
                            type="text"
                            onChange={this.props.onChange}
                            label="inputLabel.admin.firstName"
                            value={this.props.valueObj.firstName || ""}
                            errorMsg={this.props.errorObj.firstName || ""}
                            required
                        />
                    </Col>
                    <Col md="12">
                        <FormInput
                            name="middleName"
                            className="form-control-label"
                            id="middleName"
                            placeholder="inputPlaceHolder.admin.middleName"
                            type="text"
                            onChange={this.props.onChange}
                            label="inputLabel.admin.middleName"
                            value={this.props.valueObj.middleName || ""}
                            errorMsg={this.props.errorObj.middleName || ""}
                        />
                    </Col>
                    <Col md="12">
                        <FormInput
                            name="lastName"
                            className="form-control-label"
                            id="lastName"
                            placeholder="inputPlaceHolder.admin.lastName"
                            type="text"
                            onChange={this.props.onChange}
                            label="inputLabel.admin.lastName"
                            value={this.props.valueObj.lastName || ""}
                            errorMsg={this.props.errorObj.lastName || ""}
                            required
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md="12" sm="6">
                        <FormInput
                            name="emailAddress"
                            className="form-control-label"
                            id="emailAddress"
                            placeholder="inputPlaceHolder.admin.emailAddress"
                            type="email"
                            onChange={this.props.onChange}
                            label="inputLabel.admin.emailAddress"
                            value={this.props.valueObj.emailAddress || ""}
                            errorMsg={this.props.errorObj.emailAddress || ""}
                            required
                        />
                    </Col>
                    <Col md="12" sm="6" >
                        <FormInput
                            name="userCompanyName"
                            className="form-control-label"
                            id="userCompanyName"
                            placeholder="Company Name"
                            type="text"
                            onChange={this.props.onChange}
                            label="Company Name"
                            errorMsg={this.props.errorObj.userCompanyName || ""}
                            value={this.props.valueObj.userCompanyName || ""}
                            required
                        />
                    </Col>


                    {/*<Col md="12" sm="6">
            <FormInput
              name="dateOfBirth"
              className="form-control-label"
              id="dateOfBirth"
              placeholder="inputPlaceHolder.admin.dateOfBirth"
              type="date"
              onChange={this.props.onChange}
              label="inputLabel.admin.dateOfBirth"
              value={this.props.valueObj.dateOfBirth || ""}
              errorMsg={this.props.errorObj.dateOfBirth || ""}
            />
          </Col>
          <Col md="12" sm="6">
            <FormInput
              name="password"
              className="form-control-label"
              id="password"
              placeholder="inputPlaceHolder.admin.password"
              type="password"
              onChange={this.props.onChange}
              label="inputLabel.admin.password"
              errorMsg={this.props.errorObj.password || ""}
            />
          </Col>*/}
                </Row>
                <Row>

                </Row>
            </>
        );
    }
}

export default SignupForm;
